import React from 'react';
import { Box, Typography } from '@mui/material';

const Header: React.FC = () => {
    return (
        <Box textAlign="center" sx={{ mb: 4 }}>
            {/* Mako Logo */}
            <Box sx={{ mb: 0 }}>
                <img
                    src="/mako_logo.png"
                    alt="Mako Magic Logo"
                    style={{
                        height: '250px',
                        width: 'auto',
                        filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3))',
                        transition: 'all 0.3s ease',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.05)';
                        e.currentTarget.style.filter = 'drop-shadow(0 6px 12px rgba(0, 0, 0, 0.4))';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                        e.currentTarget.style.filter = 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3))';
                    }}
                />
            </Box>

            <Typography
                variant="body1"
                color="text.secondary"
                sx={{
                    mb: 3,
                    fontStyle: 'arialbold',
                    opacity: 1,
                    fontSize: '1rem'
                }}
            >
                Welcome to the Mako Magic roadmap, this is what's being worked on in the game currently!<br />
                All items are subject to change.<br />
                Click on any item to see more details.
            </Typography>
        </Box>
    );
};

export default Header;
